import { AsyncPipe, NgClass } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  ViewChild,
} from '@angular/core';
import { ResponsiveService } from '../../../services/reponsive.service';
import { Observable } from 'rxjs';
import { LucideAngularModule } from 'lucide-angular';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../boutons/button/button.component';
import { MagicHoverDirective } from '../../../directives/magic-hover.directive';

@Component({
  selector: 'app-opening',
  imports: [
    NgClass,
    LucideAngularModule,
    MagicHoverDirective,
    AsyncPipe,
    TranslateModule,
    ButtonComponent,
  ],
  templateUrl: './opening.component.html',
  styleUrl: './opening.component.scss',
  host: {
    '(mousemove)': 'mouseMove($event)',
    '(mouseleave)': 'mouseLeave()',
  },
})
export class OpeningComponent {
  @ViewChild('circle', { static: true }) circleRef!: ElementRef<HTMLDivElement>;
  @ViewChild('openingStep', { static: true })
  openingStepRef!: ElementRef<HTMLDivElement>;

  @Output() getStartedClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() arrowClick: EventEmitter<void> = new EventEmitter<void>();

  // :🤳 Responsive
  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  circleMaxSize: number = 800;
  openingWidthCenter: number = 0;
  openingHeightCenter: number = 0;

  mouseMove($event: Event) {
    const mouseEvent = $event as MouseEvent;
    this.circleRef.nativeElement.style.transition = 'none';
    const openingHeight: number =
      this.openingStepRef.nativeElement.clientHeight;
    const openingWidth: number = this.openingStepRef.nativeElement.clientWidth;
    this.openingHeightCenter = openingHeight / 2;
    this.openingWidthCenter = openingWidth / 2;
    const xCenterPosition: number = mouseEvent.x / this.openingWidthCenter;
    const yCenterPosition: number = mouseEvent.y / this.openingHeightCenter;
    const circleSize: number =
      ((xCenterPosition + yCenterPosition) / 2) * this.circleMaxSize;
    this.moveCircle(mouseEvent.x, mouseEvent.y);
    this.changeCircleSize(circleSize);
  }

  onMouseLeave() {
    this.mouseLeave();
  }

  mouseLeave() {
    this.circleRef.nativeElement.style.transition = 'all 200ms ease-in';
    this.changeCircleSize(this.circleMaxSize);
    this.moveCircle(this.openingWidthCenter, this.openingHeightCenter);
  }

  constructor(private responsiveService: ResponsiveService) {}

  private changeCircleSize(size: number): void {
    const cicleSize: string = size + 'px';
    this.circleRef.nativeElement.style.borderRadius = cicleSize;
    this.circleRef.nativeElement.style.height = cicleSize;
    this.circleRef.nativeElement.style.width = cicleSize;
  }

  private moveCircle(x: number, y: number): void {
    setTimeout(() => {
      const circle: HTMLDivElement = this.circleRef.nativeElement;
      circle.style.left = x + 'px';
      circle.style.top = y + 'px';
    }, 70);
  }
}
